import { useState, useEffect, useRef, useCallback, useMemo } from "react";
import { useNavigate } from "react-router-dom";

import { requests } from "../../../common/RestAPI";
import { base64Encoding, getTimestampToDate } from "../../../common/util";
import { SESSIONSTORAGE, FONT } from "../../../value/staticValues";
import { PAGE_URL, PLATFORM_URL } from "../../../value/Url";
import { ALERTS, ERROR_CODE, POPUP_TYPE } from "../../../value/type";

import { ValidationError } from "../../../common/ExceptionError";

import { DetailProps } from "../../../interfaceTypes/ContentsProps";
import { useTranslation } from "react-i18next";
import PodDetail from "./PodDetail";
import { PodDetailData, podLogModalContent, podUpdateModalContent } from "./PodData";



export default function PodDetailContainter(props:DetailProps) {
    const navigate = useNavigate();
    const { t } = useTranslation();
    const [infoText, setInfoText] = useState('');
    const [infoError, setInfoError] = useState(false);

    const [targetId, setTargetId] = useState(props.targetId || '');
    const [podData, setPodData] = useState<PodDetailData>();
    const [podName, setPodName] = useState("");
    const [podDesc, setPodDesc] = useState("");


    const [deploymentId, setDeploymentId] = useState("");
    const [deploymentName, setDeploymentName] = useState("");
    const [podYaml, setPodYaml] = useState("");

    const [refreshYn, setRefreshYn] = useState(false);


    useEffect(() => {
        props.setLoading(false);
        AlertFunction('');
    }, []);


    function AlertFunction(text:string, error=false) {
        setInfoText(text);
        setInfoError(error);
    }


    useEffect(() => {
        if(!targetId) {
            const localTargetId = sessionStorage.getItem(SESSIONSTORAGE.POD_TARGET_ID);
            if(localTargetId) {
                setTargetId(localTargetId);
            } else {
                navigate(`${PAGE_URL.ERRORPAGE}`);
            }
        } else {
            sessionStorage.setItem(SESSIONSTORAGE.POD_TARGET_ID, targetId);
        }
    }, [props]);


    useEffect(() => {
        if(targetId) {
            executeLoadPod();
        }
    }, [targetId]);

    useEffect(() => {
        if(targetId && refreshYn) {
            executeLoadPod();
        }
    }, [refreshYn]);


    function executeLoadPod() {
        props.setLoading(true);
        requests.get(PLATFORM_URL.POD + "/" + targetId)
        .then((response) => {
            //set data
            if (response.status === 200 && response.data) {
                setPodData(response.data)
            }
            props.setLoading(false);
            setRefreshYn(false);
        })
        .catch((error) => {
            //show error message
            props.setLoading(false);
            AlertFunction(t("MESSAGE_CANNOT_LOAD_DATA_MESSAGE"), true);
            setRefreshYn(false);
        });

    }


    function updatePodResult(data, closeYn) {
        if(data.successYn) {
            AlertFunction(t("MESSAGE_POD_UPDATE_SUCCESS_MESSAGE"));
            setRefreshYn(true);
            setTargetId(data.pod_id)
        }
    }

    function clickUpdate() {
        const data = {
            podId: targetId,
            podName: podData?.pod_name,
            podDesc: podData?.pod_description,
            podYaml: podData?.pod_yaml,
            deploymentName: podData?.deployment?.deployment_name
        }
        if(props.showSlideModalCb) {
            props.showSlideModalCb({...podUpdateModalContent, openYn: true, resultCb: updatePodResult, args: data});
        }
    }

    function clickLogs() {
        const data = {
            podId: targetId,
            podName: podData?.pod_name
        }
        if(props.showSlideModalCb) {
            props.showSlideModalCb({...podLogModalContent, openYn: true, resultCb: (v)=>null, args: data});
        }
    }


    return (
        <>
            {podData ? <PodDetail
                podData={podData}
                infoText={infoText}
                infoError={infoError}
                printLogs={clickLogs}
                updateFunction={clickUpdate}
            /> : null}
        </>
    );
}
